import _assertClassBrand from "./assertClassBrand.js";
//#region \0@oxc-project+runtime@0.151.0/helpers/esm/classPrivateFieldSet2.js
function _classPrivateFieldSet2(s, a, r) {
	return s.set(_assertClassBrand(s, a), r), r;
}
//#endregion
export { _classPrivateFieldSet2 as default };
